import apiWrapper from 'common/api/api-wrapper';
import { IAPIErrorContent } from 'common/api/type-def';

import {
	IWorkflowListItemResponse,
	IGetAllQueueResponse,
	ICreateQueueResponse,
	IWorkflowStep,
	ICreateQueueParams,
	IQueue,
	IQueueTableRow,
	IGetQueueRequestParams,
	IEditQueueRequestParams,
	IEditQueueResponse,
	ICreateWorkflowStepParams,
	IQueueSearchList,
	IWorkflowStepResponse,
	IWorkflowStepParams,
} from './type-def';

const { REACT_APP_WORKFLOW_SERVICE_URL, REACT_APP_QUEUE_SERVICE_URL } =
	process.env;

export const getAllWorkflowList = async (params: any) => {
	const sortKey = params?.sortKey ? params?.sortKey : '';
	const sortDirection = params?.sortDirection ? params?.sortDirection : '';
	const resp = await apiWrapper.get<
		IWorkflowListItemResponse,
		IAPIErrorContent
	>(
		`${REACT_APP_WORKFLOW_SERVICE_URL}?pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize}&sortBy=${sortKey}&sortOrderBy=${sortDirection}`,
	);
	return resp;
};

export const updatedWorkflowStepOrder = async (
	params: any,
	workflowId: string,
) => {
	const resp = await apiWrapper.put<any, IAPIErrorContent>(
		`${REACT_APP_WORKFLOW_SERVICE_URL}/${workflowId}/steps/order`,
		params,
	);
	return resp;
};

export const getAllWorkflowStepsForQueue = async () => {
	const resp = await apiWrapper.get<IWorkflowStep[], IAPIErrorContent>(
		`${REACT_APP_WORKFLOW_SERVICE_URL}/steps`,
	);
	return resp;
};

export const deleteWorkFlowStep = async (params: IWorkflowStep) => {
	const resp = await apiWrapper.delete<string | IAPIErrorContent>(
		`${REACT_APP_WORKFLOW_SERVICE_URL}/step/${params?.id}`,
		params,
	);
	return resp;
};

export const getAllQueueList = async (params: any) => {
	const sortKey = params?.sortKey ? params?.sortKey : '';
	const sortDirection = params?.sortDirection ? params?.sortDirection : '';
	const resp = await apiWrapper.get<IGetAllQueueResponse, IAPIErrorContent>(
		`${REACT_APP_QUEUE_SERVICE_URL}?pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize}&sortBy=${sortKey}&sortOrderBy=${sortDirection}`,
	);
	return resp;
};

export const createQueue = async (paramsObj: ICreateQueueParams) => {
	const resp = await apiWrapper.post<ICreateQueueResponse, IAPIErrorContent>(
		`${REACT_APP_QUEUE_SERVICE_URL}`,
		paramsObj,
	);
	return resp;
};

export const createWorkflowStep = async (
	paramsObj: ICreateWorkflowStepParams,
) => {
	const workFlowID = paramsObj?.workflowId;
	delete paramsObj?.workflowId;
	const resp = await apiWrapper.post<
		ICreateWorkflowStepParams,
		IAPIErrorContent
	>(`${REACT_APP_WORKFLOW_SERVICE_URL}/${workFlowID}/step`, paramsObj);
	return resp;
};

export const updateWorkflowStep = async (
	paramsObj: ICreateWorkflowStepParams,
) => {
	const resp = await apiWrapper.put<
		ICreateWorkflowStepParams,
		IAPIErrorContent
	>(
		`${process.env.REACT_APP_WORKFLOW_SERVICE_URL}/${paramsObj?.workflowId}/step/${paramsObj.workflowStepId}`,
		paramsObj,
	);
	return resp;
};

export const getSearchQueueList = async (name: string) => {
	const resp = await apiWrapper.get<IQueueSearchList[], IAPIErrorContent>(
		`${process.env.REACT_APP_QUEUE_SERVICE_URL}/search?queueName=${name}`,
	);
	return resp;
};

export const getWorkflowStepData = async (params: IWorkflowStepParams) => {
	const resp = await apiWrapper.get<IWorkflowStepResponse, IAPIErrorContent>(
		`${process.env.REACT_APP_WORKFLOW_SERVICE_URL}/${params.workflowId}/step/${params.workflowStepId}`,
	);
	return resp;
};

export const deleteQueue = async (params: IQueueTableRow) => {
	const resp = await apiWrapper.delete<string | IAPIErrorContent>(
		`${REACT_APP_QUEUE_SERVICE_URL}/${params?.queueId}`,
		params,
	);
	return resp;
};

export const getQueue = async (params: IGetQueueRequestParams) => {
	const resp = await apiWrapper.get<IQueue | IAPIErrorContent>(
		`${REACT_APP_QUEUE_SERVICE_URL}/${params?.queueId}`,
	);
	return resp;
};

export const editQueue = async (params: IEditQueueRequestParams) => {
	const resp = await apiWrapper.put<IEditQueueResponse | IAPIErrorContent>(
		`${REACT_APP_QUEUE_SERVICE_URL}/${params?.queueId}`,
		params,
	);
	return resp;
};
